/**
 * @Author: v_jppjpeng
 * @Date: 2023-4-24 10:47:02
 * @Explain: 联系人管理
 */
import { subStatusOptEnum } from '@/pages/contactManage/utils/enum/add-or-edit';
import http from '../http';
import type { TagsResponse, ValidEmailTypes } from './data.d';

const MODEL = '/businessUser';
const MODEL_UNDERLINE = '/business_user';

export default {
  // 获取导入历史列表
  getImportHistoryList(data: Record<any, any>) {
    return http.post(`${MODEL}/upload-history`, data);
  },
  // 列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data);
  },
  // 获取标签列表
  getTagList(data: Record<any, any>): Promise<TagsResponse> {
    return http.post(`${MODEL}/get-tag`, data);
  },
  // 详情
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/user-detail`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 手动创建联系人
  addASubscriberCreate(data: Record<any, any>) {
    return http.post(`${MODEL}/create`, data);
  },
  // 删除
  onDel(data: Record<string, number>) {
    return http.post(`${MODEL}/del`, data);
  },

  // 删除 多个
  onDelBatch(data: Record<string, number[]>) {
    return http.post(`${MODEL}/del-batch`, data);
  },

  // 删除全部
  onDelAll(data: Record<any, any>) {
    return http.post(`${MODEL}/deleted-all`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 删除进度
  getDelProgress() {
    return http.post(
      `${MODEL}/get-del-proceed`,
      {},
      {
        params: { switchReqToUnderline: true },
      },
    );
  },

  // 查询全部人数
  getTotalNum(data: Record<any, any>) {
    return http.post(`${MODEL}/user-num`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  // 更新订阅状态
  updateSub(data: Record<any, any>) {
    return http.post(`${MODEL}/update-subscribers`, data);
  },
  // 更新whatsapp订阅状态
  updateSubWuid(data: Record<any, any>) {
    return http.post(`${MODEL_UNDERLINE}/update_whatsapp_subscribe`, {
      status: data.status,
      user_id: data.userId,
    });
  },
  // 获取时间线
  getTimeLine(data: Record<any, any>) {
    return http.post(`${MODEL}/time-line`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取用户基本信息字段 - 可用于动态创建占位符的替换值
  getAllFields(data: Record<any, any>) {
    return http.post(`${MODEL}/get-all-fields`, data);
  },
  // 获取用户来源
  getUserFrom(data: Record<any, any>) {
    return http.post(`${MODEL}/get-user-from`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 保存上传文件信息
  onSaveUpload(data: Record<any, any>) {
    let wuidSubscriptionTypeSubOptions;
    switch (typeof data.wuidSubscriptionTypeSubOptions) {
      case 'boolean':
        wuidSubscriptionTypeSubOptions = data.wuidSubscriptionTypeSubOptions
          ? subStatusOptEnum.UN_UPDATE_SUBSCRIBED
          : subStatusOptEnum.UPDATE_SUBSCRIBED;
        break;
      default:
        wuidSubscriptionTypeSubOptions = data.wuidSubscriptionTypeSubOptions;
    }
    return http.post(
      `${MODEL}/save-upload-msg`,
      {
        ...data,
        wuidSubscribedType: Number(data.wuidSubscribedType),
        wuidSubscriptionTypeSubOptions,
      },
      {
        params: { switchReqToUnderline: true },
      },
    );
  },
  // 上传文件 - 入库进度
  getUploadParsing(data: Record<any, any>) {
    return http.post(`${MODEL}/is-parsing`, data);
  },
  // 上传文件 - 入库进度保存不展示
  saveUploadParsingDelete(data: { ids: number[]; delLi: boolean }) {
    return http.post(`${MODEL}/del-bubble`, data);
  },
  // 详情页 - 创建标签并绑定至当前邮箱信息下
  onAddUserTag(data: Record<any, any>) {
    return http.post(`${MODEL}/add-user-tag`, data);
  },
  // 详情页 - 删除当前邮箱信息下标签
  onDelUserTag(data: Record<any, any>) {
    return http.post(`${MODEL}/del-user-tag`, data);
  },
  // 上传文件 - 获取文件内邮件地址域名后缀是否正确
  onEmailVerify(data: ValidEmailTypes) {
    return http.post(`${MODEL}/email-verify`, data, {
      params: {
        // 是否弹出error提示框拦截
        unUseCommonMsg: true,
        // 协议是否进行下划线和驼峰之间转化
        switchReqToUnderline: true,
      },
    });
  },
  // 上传文件 - 批量验证邮箱有效性（单次最多验证200条）
  onBatchEmailVerify(data: { validEmail: ValidEmailTypes[] }) {
    return http.post(`${MODEL_UNDERLINE}/verify_email_list`, data, {
      params: {
        // 是否弹出error提示框拦截
        unUseCommonMsg: true,
        // 协议是否进行下划线和驼峰之间转化
        switchReqToUnderline: true,
      },
    });
  },
  // 获取联系人导出/导出中心支持by业务的开关配置，默认关，不可查看导出历史
  getCheckPermission(data: Record<any, any>) {
    return http.post(`${MODEL_UNDERLINE}/check_permission`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
